import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5c63422a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "q-pa-sm" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "well well-sm" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = {
  class: "col-md-7",
  style: {"padding-right":"5px"}
}
const _hoisted_6 = { class: "table table-nocondensed" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text__title--medium" }, [
  /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex"} }, [
    /*#__PURE__*/_createElementVNode("span", null, "Denumire:")
  ])
], -1))
const _hoisted_8 = { class: "text__input--medium bg-white" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text__title--medium" }, [
  /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex"} }, [
    /*#__PURE__*/_createElementVNode("span", null, "Status:")
  ])
], -1))
const _hoisted_10 = { class: "text__input--medium bg-white" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text__title--medium" }, [
  /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex"} }, [
    /*#__PURE__*/_createElementVNode("span", null, "CUI:")
  ])
], -1))
const _hoisted_12 = { class: "text__input--medium bg-white" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text__title--medium" }, " Reg.comert: ", -1))
const _hoisted_14 = { class: "text__input--medium bg-white" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text__title--medium" }, " Tip partener: ", -1))
const _hoisted_16 = { class: "text__input--medium bg-white" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text__title--medium" }, " Tip firma: ", -1))
const _hoisted_18 = { class: "text__input--medium bg-white" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text__title--medium" }, " Tip organizatie: ", -1))
const _hoisted_20 = { class: "text__input--medium bg-white" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text__title--medium" }, " Platitor TVA: ", -1))
const _hoisted_22 = { class: "text__input--medium bg-white" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text__title--medium" }, " Adresa: ", -1))
const _hoisted_24 = { class: "text__input--medium bg-white" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text__title--medium" }, " Nume/prenume contact: ", -1))
const _hoisted_26 = { class: "text__input--medium bg-white" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text__title--medium" }, " Functia: ", -1))
const _hoisted_28 = { class: "text__input--medium bg-white" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text__title--medium" }, " Telefon Fix: ", -1))
const _hoisted_30 = { class: "text__input--medium bg-white" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text__title--medium" }, " Telefon Mobil: ", -1))
const _hoisted_32 = { class: "text__input--medium bg-white" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text__title--medium" }, " Email: ", -1))
const _hoisted_34 = { class: "text__input--medium bg-white" }
const _hoisted_35 = {
  class: "col-md-5",
  style: {"padding-left":"2em","display":"flex","flex-direction":"column","justify-content":"flex-start","align-items":"center"}
}
const _hoisted_36 = { style: {"display":"flex","align-items":"center","justify-content":"flex-start","width":"100%"} }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text__title--medium" }, "Documente", -1))
const _hoisted_38 = {
  class: "text__label--thin",
  style: {"width":"100%","text-align":"center"}
}
const _hoisted_39 = { key: 0 }
const _hoisted_40 = { style: {"display":"flex","justify-content":"center"} }
const _hoisted_41 = {
  key: 1,
  class: "table table-bordered table-condensed table-responsive",
  style: {"width":"100%","max-height":"50vh"}
}
const _hoisted_42 = ["onClick"]
const _hoisted_43 = {
  class: "desktop-only",
  style: {"max-width":"30vw"}
}
const _hoisted_44 = { class: "mobile-only" }
const _hoisted_45 = { class: "row" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex","align-items":"center","justify-content":"center","width":"100%","border-bottom":"1px solid black"} }, null, -1))
const _hoisted_47 = { style: {"display":"flex","align-items":"left","justify-content":"left","width":"100%"} }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-top":"5px"} }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text__title--medium" }, "Conturi bancare")
], -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_50 = { style: {"display":"flex","justify-content":"center","width":"100%"} }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Editeaza cont", -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Sterge cont", -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-weight-bold" }, "Incarca fisier nou", -1))
const _hoisted_54 = {
  class: "text-grey",
  style: {"margin-top":"4px","margin-bottom":"10px"}
}
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Adaugare cont bancar partener", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_spinner_gears = _resolveComponent("q-spinner-gears")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_spinner = _resolveComponent("q-spinner")!
  const _component_DialogOpenScan = _resolveComponent("DialogOpenScan")!
  const _component_q_menu = _resolveComponent("q-menu")!
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_td = _resolveComponent("q-td")!
  const _component_q_tr = _resolveComponent("q-tr")!
  const _component_q_table = _resolveComponent("q-table")!
  const _component_q_linear_progress = _resolveComponent("q-linear-progress")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _component_q_bar = _resolveComponent("q-bar")!
  const _component_EditPartenerCont = _resolveComponent("EditPartenerCont")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loadingPartenerData)
      ? (_openBlock(), _createBlock(_component_q_spinner_gears, {
          key: 0,
          color: "primary",
          size: "4em",
          class: "absolute-center"
        }))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("table", _hoisted_6, [
                  _createElementVNode("tbody", null, [
                    _createElementVNode("tr", null, [
                      _hoisted_7,
                      _createElementVNode("td", _hoisted_8, _toDisplayString(_ctx.partener.denumire), 1)
                    ]),
                    _createElementVNode("tr", null, [
                      _hoisted_9,
                      _createElementVNode("td", _hoisted_10, _toDisplayString(_ctx.getDenStatus(_ctx.partener.is_activ as string)), 1)
                    ]),
                    _createElementVNode("tr", null, [
                      _hoisted_11,
                      _createElementVNode("td", _hoisted_12, _toDisplayString(_ctx.partener.cui), 1)
                    ]),
                    _createElementVNode("tr", null, [
                      _hoisted_13,
                      _createElementVNode("td", _hoisted_14, _toDisplayString(_ctx.partener.reg_comert), 1)
                    ]),
                    _createElementVNode("tr", null, [
                      _hoisted_15,
                      _createElementVNode("td", _hoisted_16, _toDisplayString(_ctx.getDenTip(_ctx.partener.tip as string)), 1)
                    ]),
                    _createElementVNode("tr", null, [
                      _hoisted_17,
                      _createElementVNode("td", _hoisted_18, _toDisplayString(_ctx.partener.tip_firma), 1)
                    ]),
                    _createElementVNode("tr", null, [
                      _hoisted_19,
                      _createElementVNode("td", _hoisted_20, _toDisplayString(_ctx.partener.tip_organizatie), 1)
                    ]),
                    _createElementVNode("tr", null, [
                      _hoisted_21,
                      _createElementVNode("td", _hoisted_22, _toDisplayString(_ctx.getDenIsTva(_ctx.partener.is_tva)), 1)
                    ]),
                    _createElementVNode("tr", null, [
                      _hoisted_23,
                      _createElementVNode("td", _hoisted_24, _toDisplayString(_ctx.partener.adresa), 1)
                    ]),
                    _createElementVNode("tr", null, [
                      _hoisted_25,
                      _createElementVNode("td", _hoisted_26, _toDisplayString(_ctx.partener.nume_prenume_contact), 1)
                    ]),
                    _createElementVNode("tr", null, [
                      _hoisted_27,
                      _createElementVNode("td", _hoisted_28, _toDisplayString(_ctx.partener.functia), 1)
                    ]),
                    _createElementVNode("tr", null, [
                      _hoisted_29,
                      _createElementVNode("td", _hoisted_30, _toDisplayString(_ctx.partener.numar_telefon_fix), 1)
                    ]),
                    _createElementVNode("tr", null, [
                      _hoisted_31,
                      _createElementVNode("td", _hoisted_32, _toDisplayString(_ctx.partener.numar_telefon_mobil), 1)
                    ]),
                    _createElementVNode("tr", null, [
                      _hoisted_33,
                      _createElementVNode("td", _hoisted_34, _toDisplayString(_ctx.partener.email), 1)
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("div", null, [
                    _hoisted_37,
                    _withDirectives(_createElementVNode("div", _hoisted_38, "Nimic atasat", 512), [
                      [_vShow, _ctx.partener.scan_documents != null && _ctx.partener.scan_documents.length==0 && !_ctx.uploadingFileToServer]
                    ])
                  ]),
                  (_ctx.user.auth_for_upload_scan=='y' )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                        _createVNode(_component_q_btn, {
                          flat: "",
                          color: "primary",
                          icon: "add_box",
                          "no-caps": "",
                          disable: _ctx.loadingPartenerData,
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openFormUploadFile('y')))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_tooltip, {
                              "transition-show": "rotate",
                              "transition-hide": "rotate"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Incarca document nou ")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["disable"])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_40, [
                  (_ctx.uploadingFileToServer)
                    ? (_openBlock(), _createBlock(_component_q_spinner, {
                        key: 0,
                        color: "primary",
                        size: "3em",
                        thickness: 10
                      }))
                    : (_openBlock(), _createElementBlock("table", _hoisted_41, [
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.partener.scan_documents, (scan_document) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: scan_document.appid
                            }, [
                              _createElementVNode("td", null, [
                                _createElementVNode("span", {
                                  class: "material-icons cursor-pointer",
                                  style: {"color":"red","font-size":"1.3rem"},
                                  onClick: ($event: any) => (_ctx.askIfRemoveScan(scan_document))
                                }, "delete_forever", 8, _hoisted_42)
                              ]),
                              _createElementVNode("td", null, _toDisplayString(scan_document.file_ext), 1),
                              _createElementVNode("td", null, _toDisplayString(_ctx.humanReadableBytes(scan_document.file_size)), 1),
                              _createElementVNode("td", null, [
                                _createElementVNode("div", _hoisted_43, _toDisplayString(scan_document.description), 1),
                                _createElementVNode("div", _hoisted_44, _toDisplayString(scan_document.description), 1)
                              ]),
                              _createElementVNode("td", null, [
                                _createVNode(_component_q_btn, {
                                  round: "",
                                  color: "black",
                                  icon: "cloud_download",
                                  size: "xs"
                                }),
                                _createVNode(_component_q_menu, {
                                  fit: "",
                                  "transition-show": "scale",
                                  "transition-hide": "scale"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_DialogOpenScan, {
                                      appid: scan_document.appid,
                                      type_scan: "Parteneri"
                                    }, null, 8, ["appid"])
                                  ]),
                                  _: 2
                                }, 1024)
                              ])
                            ]))
                          }), 128))
                        ])
                      ]))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_45, [
              _hoisted_46,
              _createElementVNode("div", _hoisted_47, [
                _hoisted_48,
                _createElementVNode("div", null, [
                  _createVNode(_component_q_btn, {
                    flat: "",
                    color: "primary",
                    icon: "add_box",
                    "no-caps": "",
                    disable: _ctx.loadingPartenerData,
                    onClick: _ctx.openFormAssetPlan
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_tooltip, {
                        "transition-show": "rotate",
                        "transition-hide": "rotate"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Adaugare cont nou ")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["disable", "onClick"])
                ]),
                _hoisted_49
              ]),
              _createElementVNode("div", _hoisted_50, [
                (_ctx.loadingPartenerConturi)
                  ? (_openBlock(), _createBlock(_component_q_spinner, {
                      key: 0,
                      color: "primary",
                      size: "3em",
                      thickness: 10
                    }))
                  : (_openBlock(), _createBlock(_component_q_table, {
                      key: 1,
                      dense: "",
                      "rows-per-page-options": [0],
                      rows: _ctx.partenerConturi,
                      columns: _ctx.partenerConturiListColumns,
                      "visible-columns": _ctx.visiblePartenerConturiListColumns,
                      "row-key": "appid",
                      filter: _ctx.filterPartenerConturiList,
                      loading: _ctx.loadingPartenerConturi,
                      pagination: _ctx.myPagination,
                      class: "table table-bordered table-condensed table-responsive"
                    }, {
                      top: _withCtx(() => [
                        _createVNode(_component_q_space),
                        _createVNode(_component_q_input, {
                          dense: "",
                          debounce: "300",
                          color: "primary",
                          modelValue: _ctx.filterPartenerConturiList,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filterPartenerConturiList) = $event))
                        }, {
                          append: _withCtx(() => [
                            _createVNode(_component_q_icon, { name: "search" })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      body: _withCtx((props) => [
                        _createVNode(_component_q_tr, { props: props }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_td, {
                              key: "moneda",
                              props: props,
                              sortable: true,
                              style: {"white-space":"pre-wrap","word-wrap":"break-word"}
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(props.row.moneda), 1)
                              ]),
                              _: 2
                            }, 1032, ["props"]),
                            _createVNode(_component_q_td, {
                              key: "denumire_banca",
                              props: props,
                              sortable: true,
                              style: {"white-space":"pre-wrap","word-wrap":"break-word"}
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(props.row.denumire_banca), 1)
                              ]),
                              _: 2
                            }, 1032, ["props"]),
                            _createVNode(_component_q_td, {
                              key: "swift",
                              props: props,
                              sortable: true,
                              style: {"white-space":"pre-wrap","word-wrap":"break-word"}
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(props.row.swift), 1)
                              ]),
                              _: 2
                            }, 1032, ["props"]),
                            _createVNode(_component_q_td, {
                              key: "iban",
                              props: props,
                              sortable: true,
                              style: {"white-space":"pre-wrap","word-wrap":"break-word"}
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(props.row.iban), 1)
                              ]),
                              _: 2
                            }, 1032, ["props"]),
                            _createVNode(_component_q_td, {
                              key: "appid",
                              props: props,
                              sortable: false
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_icon, {
                                  name: 'edit',
                                  class: _normalizeClass('text-blue cursor-pointer pencil'),
                                  style: {"font-size":"1.2rem","margin-left":"auto"},
                                  onClick: ($event: any) => (_ctx.onPressEditRowCont(props.row))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_q_tooltip, null, {
                                      default: _withCtx(() => [
                                        _hoisted_51
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"]),
                                _createVNode(_component_q_icon, {
                                  name: "delete_forever",
                                  class: "text-red cursor-pointer",
                                  style: {"font-size":"1.3rem"},
                                  onClick: ($event: any) => (_ctx.askIfDeleteCont(props.row))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_q_tooltip, null, {
                                      default: _withCtx(() => [
                                        _hoisted_52
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"])
                              ]),
                              _: 2
                            }, 1032, ["props"])
                          ]),
                          _: 2
                        }, 1032, ["props"])
                      ]),
                      _: 1
                    }, 8, ["rows", "columns", "visible-columns", "filter", "loading", "pagination"]))
              ])
            ])
          ])
        ])),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.dialogUploadFile,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.dialogUploadFile) = $event)),
      position: "top"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, { style: {"width":"350px"} }, {
          default: _withCtx(() => [
            _createVNode(_component_q_linear_progress, {
              value: 0.6,
              color: "pink"
            }),
            _createVNode(_component_q_card_section, { class: "column no-wrap" }, {
              default: _withCtx(() => [
                _hoisted_53,
                _createElementVNode("div", _hoisted_54, [
                  _createVNode(_component_q_input, {
                    counter: "",
                    outlined: "",
                    modelValue: _ctx.uploadScanTitle,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.uploadScanTitle) = $event)),
                    label: "Titlu document (minim 4 caractere)",
                    dense: "",
                    maxlength: "200"
                  }, null, 8, ["modelValue"])
                ]),
                _withDirectives(_createElementVNode("input", {
                  type: "file",
                  name: "fileToUpload",
                  id: "fileToUpload",
                  ref: "myFileToUpload",
                  onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.prepareForUpload($event))),
                  style: {"margin-bottom":"10px"}
                }, null, 544), [
                  [_vShow, _ctx.uploadScanTitle.length>3]
                ]),
                _withDirectives(_createVNode(_component_q_btn, {
                  disable: !(_ctx.uploadScanTitle.length>3),
                  icon: "cloud_upload",
                  color: "white",
                  "text-color": "black",
                  label: "Salveaza pe server",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.uploadFile())),
                  loading: _ctx.uploadingFileToServer,
                  style: {"margin-bottom":"5px"}
                }, null, 8, ["disable", "loading"]), [
                  [_vShow, _ctx.checkIfFileIsSelected]
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.visibleDialogPartenerCont,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.visibleDialogPartenerCont) = $event)),
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, { style: {"min-width":"60vw","max-width":"80vw"} }, {
          default: _withCtx(() => [
            _createVNode(_component_q_bar, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_icon, { name: "add_box" }),
                _hoisted_55,
                _createVNode(_component_q_space),
                _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                  dense: "",
                  flat: "",
                  icon: "close"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_tooltip, null, {
                      default: _withCtx(() => [
                        _createTextVNode("Close")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })), [
                  [_directive_close_popup]
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                _createVNode(_component_EditPartenerCont, {
                  frenunt: _ctx.renuntEditarePartenerCont,
                  fonsave: _ctx.getConturi,
                  appid_partener: _ctx.partener.appid,
                  appid: _ctx.appid_cont
                }, null, 8, ["frenunt", "fonsave", "appid_partener", "appid"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}